export function initGlobals() {
    window.getCsrfToken = function () {
        var el = document.querySelector('meta[name="csrf-token"]');
        return el && el.content ? el.content : '';
    };

    window._tryStorePendingYandexToken = function () {
        var token = sessionStorage.getItem('pending_yandex_token');
        if (!token) return;
        var csrfToken = window.getCsrfToken();
        if (!csrfToken) return;
        sessionStorage.removeItem('pending_yandex_token');
        var state = sessionStorage.getItem('pending_yandex_state') || '';
        sessionStorage.removeItem('pending_yandex_state');
        fetch('/api/seo/webmaster/store-token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
            body: JSON.stringify({ access_token: token })
        }).then(function (r) {
            if (r.ok) {
                if (state === 'from_settings') {
                    window.location.href = '/settings#integrations?connected=1';
                }
            } else {
                console.error('Yandex OAuth store-token: HTTP', r.status);
                sessionStorage.setItem('pending_yandex_token', token);
                sessionStorage.setItem('pending_yandex_state', state);
            }
        }).catch(function (err) {
            console.error('Yandex OAuth store-token error:', err);
            sessionStorage.setItem('pending_yandex_token', token);
            sessionStorage.setItem('pending_yandex_state', state);
        });
    };

    handleYandexOAuthHash();
}

function handleYandexOAuthHash() {
    try {
        if (window.location.hash && window.location.hash.indexOf('access_token=') !== -1) {
            var params = new URLSearchParams(window.location.hash.substring(1));
            var token  = params.get('access_token');
            var state  = params.get('state') || '';
            if (token) {
                if (window.history && window.history.replaceState) {
                    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
                }
                sessionStorage.setItem('pending_yandex_token', token);
                sessionStorage.setItem('pending_yandex_state', state);
            }
        }
        if (typeof window._tryStorePendingYandexToken === 'function') {
            window._tryStorePendingYandexToken();
        }
        if (sessionStorage.getItem('pending_yandex_token') && !window.getCsrfToken()) {
            var banner = document.getElementById('yandex-oauth-expired-banner');
            if (banner) banner.style.display = 'flex';
        }
    } catch (e) {}
}
